// Этот миксин нужен тем компонентам ии страницам, которые ввключают в себя компонент ArticleInfiniteList

import APIService from '@/apiservices/APIService.js'
export const articlesInfinitListMixin = {
  data() {
    return {
      startpage: 1,
      // тут лежат не очищенные от сервисной информации страницы с артиклами
      // сами объекты Article лежат в results[0]
      // а это значит, что у нас все рработает ТОЛЬКО при количестве фртиклов на странице равной 1!
      articlesList: [],

      errorLoadingData: '',
      currentArticle: null,
      filterOptions: {},
      articleTitlesList: [],

      noArticlesFound: false,

      loadingData: false
    }
  },

  created() {
    window.onbeforeunload = function() {
      window.scrollTo(0, 0)
    }
  },

  methods: {
    // Хэндлеры, которые вызываются по событиям от ArticlesInfiniteList

    addArticlesToBottomHandler($state) {
      this.fetchArticles('bottom', $state)
    },

    addArticlesToTopHandler($state) {
      this.fetchArticles('top', $state)
    },

    currentArticleChangeHandler(article) {
      this.currentArticle = article
    },

    //////

    fetchArticles(addingDirection, $state) {
      let page = 0

      if (addingDirection == 'top') {
        page = this.startpage - 1
        if (this.articlesList.length > 0) {
          page = this.articlesList[0].current - 1
        }
        if (page == 0) {
          $state.complete()
          return
        }
      } else if (addingDirection == 'bottom') {
        page = this.startpage
        if (this.articlesList.length > 0) {
          page = this.articlesList[this.articlesList.length - 1].current + 1
        }
      } else {
        return
      }

      APIService.getArticles(this.filterOptions, page)
        .then(({ data }) => {
          if (data.count == 0) {
            //ничего не нашли
            this.noArticlesFound = true
            $state.complete()
          } else {
            if (addingDirection == 'top') {
              this.addArticlesToTop(data)
            } else if (addingDirection == 'bottom') {
              this.addArticlesToBottom(data)
            }

            $state.loaded()
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 404) {
            $state.complete()
          } else {
            this.errorLoadingData = error
            $state.error()
            console.log(
              'There was an error in ArticlesInJourney API call:',
              error
            )
          }
        })
    },

    addArticlesToBottom(data) {
      this.articlesList.push(data)
    },

    addArticlesToTop(data) {
      this.articlesList.unshift(data)
    },

    resetArticlesList() {
      this.articlesList = []
      this.noArticlesFound = false
    },

    goToPageHandler(page) {
      this.resetArticlesList()
      this.startpage = page
    },

    fetchArticleTitles() {
      this.loadingData = true

      APIService.getArticleTitles(this.filterOptions)
        .then(({ data }) => {
          this.articleTitlesList = data
          console.log('Article titles:', this.articleTitlesList)
          this.loadingData = false
        })
        .catch(error => {
          this.loadingData = false
          console.log(
            'There was an error in ArticlesInJourney API call:',
            error
          )
        })
    }
  }
}
